import { Component } from "@angular/core";
import { FeatureFlagsService } from "src/app/services/feature-flag/feature-flag.service";

@Component({
  selector: 'app-upgrade-account-wrapper',
  template: `
    <app-plans-page *ngIf="useRebranded"></app-plans-page>
    <app-upgrade-account *ngIf="!useRebranded"></app-upgrade-account>
  `
})
export class UpgradeAccountWrapperComponent {
  public useRebranded: boolean;

  constructor(private featureFlagService: FeatureFlagsService) {
    this.useRebranded = this.featureFlagService.isEnabled('useRebrandedLayout');
  }
}
